import * as React from "react";
import { Stack } from "@mui/material";
import PrintoutTable from "../tables/PrintoutTable";
import PrintoutsFilter from "../filters/PrintoutsFilter";
import { useHasScope } from "../../../../../config/globalConfig";
import { VIEW_PRINTOUTS_HISTORY } from "../../../utils/FinanceScope";
import NotAuthorizedDialog from "../../../../authentication/component/NotAuthorizedDialog";

function Printouts() {

    const hasScope = useHasScope;

    if (!hasScope(VIEW_PRINTOUTS_HISTORY)) return <NotAuthorizedDialog />

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <PrintoutsFilter/>
            <PrintoutTable/>
        </Stack>
    ) 
}

export default Printouts;